import { Button } from "@/components/ui/button";
import { LinkButton } from "@/components/ui/buttons/link-button";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";
import { MyContainer } from "../../components/MyContainer";
import OrderAsyncTable from "./component/order-async-table";

export default function OrdersPage() {
  const { t } = useTranslation('order');
  const [, setLocation] = useLocation();
  const [refreshPage, setRefreshPage] = useState(false);

  return (
    <MyContainer
      title={t('title')}
      subtitle={t('description')}
      enableBack={false}
      actions={
        <>
          <LinkButton label={t('order')} onClick={() => setLocation("/orders/new")} />
          <Button
            variant="outline"
            size="sm"
            onClick={() => setRefreshPage((prev) => !prev)}
          >
            {t('refresh')}
          </Button>
        </>
      }
    >
      <OrderAsyncTable refreshPage={refreshPage} />
    </MyContainer>
  );
}
